var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.585 19.2039H4.31774C2.72691 19.2039 1.77283 17.4366 2.64565 16.1066L9.61337 5.48912C10.3931 4.30099 12.1284 4.28231 12.9336 5.45338L20.2331 16.0709C21.1454 17.3979 20.1953 19.2039 18.585 19.2039Z",
    fill: "#FFAE11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9651 8.324V11.756C11.9651 12.12 11.9471 12.478 11.9111 12.83C11.8751 13.178 11.8271 13.548 11.7671 13.94H10.7651C10.7051 13.548 10.6571 13.178 10.6211 12.83C10.5851 12.478 10.5671 12.12 10.5671 11.756V8.324H11.9651ZM10.3391 16.184C10.3391 16.06 10.3611 15.942 10.4051 15.83C10.4531 15.718 10.5171 15.622 10.5971 15.542C10.6811 15.462 10.7791 15.398 10.8911 15.35C11.0031 15.302 11.1231 15.278 11.2511 15.278C11.3751 15.278 11.4931 15.302 11.6051 15.35C11.7171 15.398 11.8131 15.462 11.8931 15.542C11.9731 15.622 12.0371 15.718 12.0851 15.83C12.1331 15.942 12.1571 16.06 12.1571 16.184C12.1571 16.312 12.1331 16.432 12.0851 16.544C12.0371 16.652 11.9731 16.746 11.8931 16.826C11.8131 16.906 11.7171 16.968 11.6051 17.012C11.4931 17.06 11.3751 17.084 11.2511 17.084C11.1231 17.084 11.0031 17.06 10.8911 17.012C10.7791 16.968 10.6811 16.906 10.5971 16.826C10.5171 16.746 10.4531 16.652 10.4051 16.544C10.3611 16.432 10.3391 16.312 10.3391 16.184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarning);
export default __webpack_public_path__ + "static/media/yellowWarning.469542314525be84081dfec12098cc3a.svg";
export { ForwardRef as ReactComponent };